<template>
  <v-container 
    class="justify-center py-12"
    fill-height
    style="gap: 0px"
  >
    <section 
      :class="[
        {'d-flex justify-center': $vuetify.breakpoint.mdAndUp},
        {'d-flex flex-column align-center': !$vuetify.breakpoint.mdAndUp}
      ]" 
      :style="{
        width: '100%',
        gap: $vuetify.breakpoint.mdAndUp ? '0px' : '24px'
      }"
    >
      <div 
        v-for="(card, index) in getItems"
        :ref="`ticket-${index}`"
        :class="['card', {'featured-card': card.destaque}]"
        :style="{
          height: `${card.destaque ? cardHeights.featured : cardHeights.others}px`,
          'background-color': showFirstRowElement(index) ? layout.bgColor : 'transparent',
          '--featuredBgColor1': layout.featuredBgColor1,
          'border-color': `${layout.accentColor1} !important`, 
          '--widthCard': `${layout.width || width}px`,
          '--featuredWidthCard': `${layout.featuredWidth || featuredWidth}px`  
        }"
        :key="index"
        @click="$emit('onBuyTicket', card)"
      >
        <span v-if="showFirstRowElement(index)">
          <div class="d-flex justify-start" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
            <h1 
              :ref="`ticket-title-${index}`" 
              class="title" 
              :style="{color: !card.destaque ? layout.textColor1 : layout.priceColor}" 
              @mouseenter="isEllipsed(`ticket-title-${index}`)" 
              @mouseleave="resetTooltip"
            >
              <v-tooltip bottom max-width="220" :disabled="!infoTooltip.show" :color="!card.destaque ? layout.btnColor1.bg : layout.btnColor2.bg">
                <template v-slot:activator="{ on }">
                  <span 
                    v-on="on" 
                    :style="{
                      color: !card.destaque ? layout.textColor1 : layout.priceColor,
                    }"
                  >
                    {{getTicketName(card)}}
                  </span>
                </template>
                <div :style="{'font-size': '0.8rem'}">
                  {{getTicketName(card)}}
                </div>
              </v-tooltip>
            </h1>
          </div>

          <div class="d-flex justify-center" :style="{color: !card.destaque ? layout.accentColor2 : layout.priceColor}">
            <div class="d-flex align-center pr-1 price-2">R$</div>
            <h2 class="price">{{formatValue(card.valor)}}</h2>
            <span class="pt-2 price-2" :style="{color: !card.destaque ? layout.accentColor2 : layout.priceColor}">,00</span>
          </div>
          <!-- <span class="d-block msg" v-html="card.mensagem"></span> -->

          <div class="d-flex flex-column pt-4" style="gap: 12px">
            <Button 
              :label="settings.itemsV2Button" 
              :color="!card.destaque ? layout.btnColor1.bg : layout.btnColor2.bg" 
              textSize="0.75rem" 
              :textColor="!card.destaque ? layout.btnColor1.text : layout.btnColor2.text" 
            />
            <!-- <Button label="Comprar como parceiro" outlined text-color="bt_color" text-size="0.75rem" @click="$emit('onBuyTicketLikePartner', card)"/> -->
          </div>

          <!-- For small screen Devices  -->
          <div v-if="!$vuetify.breakpoint.mdAndUp" class="d-flex flex-column align-center pt-6" style="gap: 4px">
            <span 
              v-if="
                settings.itemsV2Message && 
                showItemsWithAtLeastOneOccurence.length > 0 && 
                showItemsWithAtLeastOneOccurence.some(group => group.items.length > 0)
              " 
              class="d-block pb-4 group-title"
              :style="{color: !card.destaque ? layout.itemColor : layout.priceColor}"
            >
              {{settings.itemsV2Message}}
            </span>

            <div v-for="(group, i) in showItemsWithAtLeastOneOccurence" :key="`${card.nome}-item-${i}`" style="width: 90%">
              <div 
                v-if="group.group && group.items.length > 0" 
                :class="['d-flex flex-column align-start group-title pb-3', {'pt-3': i !== 0}]"
                :style="{color: !card.destaque ? layout.itemColor : layout.priceColor}"
              >
                {{group.group}}
              </div>
              <section
                v-for="(itemGroup, indexGroup) in group.items" 
                :key="`${group.group}-itemGroup-${indexGroup}`"
                :class="['d-flex justify-start align-center', {'pt-3': indexGroup !== 0}]"  
              >
                <div class="item-circle mr-3">
                  <div 
                    v-if="card.itens_incluidos.includes(itemGroup.id)" 
                    class="item-circle" 
                    style="position: absolute !important; top: 0; left: 0; backgroundColor: red !important;"
                    :style="{
                      position: 'absolute !important',
                      top: 0,
                      left: 0,
                      backgroundColor: layout.checkColor1.bgChecked
                    }"
                  ></div>

                  <v-icon 
                    v-if="card.itens_incluidos.includes(itemGroup.id)" 
                    size="11" 
                    style="padding-top: 2px" 
                    :color="layout.checkColor1.colorChecked"
                  >
                    fa-solid fa-check
                  </v-icon>

                  <v-icon v-else size="20" :color="layout.checkColor1.colorNotChecked">
                    fa-light fa-circle-xmark
                  </v-icon>
                </div>
                <div 
                  class="item-desc" 
                  :style="{color: card.itens_incluidos.includes(itemGroup.id) ? layout.priceColor : layout.textColor2}"
                >
                  {{itemGroup.description}}
                </div>
              </section>
            </div>
          </div>
        </span>
      </div>
    </section>

    <!-- For devices with screen greather than small  -->
    <div v-if="$vuetify.breakpoint.mdAndUp && items.length > 0">
      <div v-for="group in showItemsWithAtLeastOneOccurence" :key="group.id" class="group-container">
        <section 
          v-for="(itemGroup, indexItemGroup) in group.items" 
          :key="itemGroup.id"
          :class="['d-flex justify-center group-row']" 
          :style="{
            width: '100%',
            gap: '0px',
            'border-color': `${layout.accentColor1} !important`
          }"        
        >
          <div 
            class="card-2 items"
            :style="{
              'border-color': `${layout.accentColor1} !important`, 
              backgroundColor: layout.itemBgColor,
              color: layout.itemColor,
              '--widthCard': `${layout.width || width}px`,
              '--featuredWidthCard': `${layout.featuredWidth || featuredWidth}px`
            }"
          >
            <div 
              v-if="indexItemGroup === 0"
              class="cell-group-title"
              :style="{backgroundColor: layout.itemBgColor}"
            >
              {{group.group}}
            </div>
            {{itemGroup.description}}
          </div>
          
          <div 
            v-for="(cardItem, cardItemIndex) in items"
            :key="`${cardItem.group}-${cardItemIndex}`"
            :class="['card-2', {'featured-card2': cardItem.destaque}]"
            :style="{
              'border-color': `${layout.accentColor1} !important`,
              'border-top-color': `${cardItem.destaque ? layout.btnColor1.bg : layout.accentColor1}`,
              backgroundColor: cardItem.destaque ? layout.featuredBgColor1 : layout.bgColor,
              '--widthCard': `${layout.width || width}px`,
              '--featuredWidthCard': `${layout.featuredWidth || featuredWidth}px`
            }"
          >
            <div class="item-circle-2 mr-3">
              <div 
                v-if="cardItem.itens_incluidos.includes(itemGroup.id)" 
                class="item-circle-2" 
                :style="{
                  position: 'absolute !important',
                  top: 0,
                  left: '20%',
                  backgroundColor: layout.checkColor1.bgChecked
                }"
              ></div>

              <v-icon 
                v-if="cardItem.itens_incluidos.includes(itemGroup.id)" 
                size="16" 
                style="padding-top: 2px; padding-left: 12px" 
                :color="layout.checkColor1.colorChecked"
              >
                fa-solid fa-check
              </v-icon>
            </div>                   
          </div>
        </section>
      </div>
    </div>
  </v-container>
</template>

<script> 
import {mapGetters} from 'vuex'
import Button from '../../_v2/ui/Button.vue'
import { TICKETS_GET_DEFAULT_WIDTH } from '../../../schemas/sections'

export default {
  name: 'newLayout6',
  components: {Button},
  props: {
    settings: {type: Object},
    splitArray: {type: Array},
    openCheckout: {type: Function},
    getTicketsForLayoutV2: {type: Function}
  },

  computed: {
    ...mapGetters(['products', 'loadingCheckout']),
    layout () {
      return this.settings.layoutStyle.newLayout6
    },

    getItems () {
      if (this.$vuetify.breakpoint.mdAndUp) return [{}, ...this.items]
      else return this.items
    },

    showItemsWithAtLeastOneOccurence () {
      const itemsV2DescParsed = JSON.parse(JSON.stringify(this.settings.itemsV2Desc))
      itemsV2DescParsed.forEach(group => {
        const uselessItem = []

        group.items.forEach((item) => {
          const isItBeingUsed = this.settings.itemsV2.some(ticket => ticket.itens_incluidos.includes(item.id))
          if (!isItBeingUsed) uselessItem.push(item.id)
        })

        group.items = group.items.filter(item => !uselessItem.includes(item.id))
      })
      return itemsV2DescParsed      
    }
  },

  data: () => ({
    cardHeights: {featured: null, others: null},
    infoTooltip: {ref: '', show: false},
    items: [],
    width: TICKETS_GET_DEFAULT_WIDTH('newLayout6').width,
    featuredWidth: TICKETS_GET_DEFAULT_WIDTH('newLayout5').featuredWidth
  }),

  mounted () {
    if (this.products && this.products.products) this.getTickets(this.products.products)
  },

  methods: {
    showFirstRowElement (index) {
      if (this.$vuetify.breakpoint.mdAndUp) return index !== 0
      return true
    },

    getTickets (products) {
      if (products && products.length > 0) {
        this.items = this.getTicketsForLayoutV2(this.settings.itemsV2)
        this.$forceUpdate()
      } else this.items = []
    },

    getTicketName (item) {
      let productName = 'Ingresso'
      if (item && this.settings.showTypeOfTicket) productName = item.nome_tipo ? `${item.nome} - ${item.nome_tipo}` : item.nome
      else if (item && !this.settings.showTypeOfTicket) productName = item.nome
      
      return productName      
    },    

    formatValue (price) {
      const formatedValue = price ? price.split(',00')[0] : price
      return formatedValue
    },

    isEllipsed (ref) {
      const cardTitle = this.$refs[ref]
      const isCardTitleEllipsed = cardTitle[0].scrollWidth > cardTitle[0].clientWidth
      Object.assign(this.infoTooltip, {ref, show: isCardTitleEllipsed})  
    },

    resetTooltip () {
      Object.assign(this.infoTooltip, {ref: '', show: false})  
    }    
  },

  watch: {
    'products.products': {
      deep: true,
      handler (v) { this.getTickets(v) }
    },

    'settings.itemsV2': {
      deep: true,
      handler (v) { 
        this.getTickets(v) 
      },
    },

    'settings.itemsV2Message': {
      deep: true,
      handler () { 
        this.getTickets(this.settings.itemsV2) 
      },
    }    
  },    
}
</script>

<style scoped>
.card, .card-2 {
  padding: 16px;
  width: var(--widthCard) !important;
  text-align: center;
  position: relative;
  transition: all 0.3s;
}

.card:hover {
  transform: translateY(-8px);
  cursor: pointer;
}

.card {
  border-radius: 0px;
  border: 1px solid;
  border-bottom: 0;
  border-right: 0
}

.card:nth-of-type(1) {
  border: 0
}

.card:nth-of-type(2) {
  border-top-right-radius: 0px;
  border-top-left-radius: 8px;
}

.card:last-of-type {
  border-top-left-radius: 0px;
  border-top-right-radius: 8px;
  border-right: 1px solid
}

.card .title {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 20px !important;
  line-height: 124%;
  padding-bottom: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  z-index: 1
}

.card .price {
  font-size: 36px;
  line-height: 124%;
  letter-spacing: 1px;
  font-weight: 700;
}

.card .price-2 {
  font-size: 13px
}

.card .msg {
  font-size: 12px;
  font-weight: 400;
  line-height: 124%;
}

.group-title {
  font-size: 12.5px;
  font-weight: 700;
  line-height: 124%;
}

.featured-card {
  width: var(--featuredWidthCard) !important;
  position: relative;
  background-color: var(--featuredBgColor1) !important
}

.featured-card2 {
  width: var(--featuredWidthCard) !important;
}

.item-circle, .item-circle-2 {
  height: 19px;
  width: 19px;
  max-height: 19px;
  max-width: 19px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: relative;
}

.item-circle-2 {
  width: 30px;
  height: 30px;
  max-height: 30px;
  max-width: 30px;
}

.item-desc {
  display: flex;
  flex: 1;
  font-size: 12.5px;
  line-height: 124%;
  font-weight: 400;
  text-align: start;
}

.card-2 {
  border-radius: 0px;
  border: 1px solid;
  border-right: 0;
  border-bottom: 0;  
  font-size: 12.5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cell-group-title {
  position: absolute;
  top: -10px;
  font-size: 13px;
  font-weight: 900;
  padding: 0 4px 0 4px
}

/* Lista de itens  */
.card-2.items{
  border-right: 0;
  border-bottom: 0
}

.group-container:first-of-type .group-row:first-of-type .card-2.items {
  border-top-left-radius: 8px;
}

.group-container:last-of-type .group-row:last-of-type .card-2.items {
  border-bottom-left-radius: 8px;
  border-bottom: 1px solid !important
}

/* Fim lista de itens */

.group-container:last-of-type .group-row:last-of-type .card-2 {
  border-bottom: 1px solid !important;
}

.group-row .card-2:last-of-type {
  border-right: 1px solid !important;
}

.group-container:last-of-type .group-row:last-of-type .card-2:last-child {
  border-bottom-right-radius: 8px;
  border-bottom: 1px solid !important;
}

@media (max-width: 600px) {
  .card {
    width: 80% !important;
    border-radius: 8px !important;
  } 
}
</style>